module.exports = __webpack_public_path__ + "img/blue_044.512ae967.png";